export default {"src":"/_next/static/media/dansen.8035dc76.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};